var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 45 63",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5.25C10.406.25.625 10.031.625 22.125.625 38.531 22.5 62.75 22.5 62.75s21.875-24.219 21.875-40.625C44.375 10.031 34.594.25 22.5.25zm0 29.688c-4.313 0-7.813-3.5-7.813-7.813s3.5-7.813 7.813-7.813 7.813 3.5 7.813 7.813-3.5 7.813-7.813 7.813z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBmaWxsPSJub25lIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0NSA2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxwYXRoIGQ9Ik0yMi41LjI1QzEwLjQwNjIuMjUuNjI1IDEwLjAzMTIuNjI1IDIyLjEyNS42MjUgMzguNTMxMiAyMi41IDYyLjc1IDIyLjUgNjIuNzVzMjEuODc1LTI0LjIxODggMjEuODc1LTQwLjYyNUM0NC4zNzUgMTAuMDMxMiAzNC41OTM4LjI1IDIyLjUuMjV6bTAgMjkuNjg3NWMtNC4zMTI1IDAtNy44MTI1LTMuNS03LjgxMjUtNy44MTI1czMuNS03LjgxMjUgNy44MTI1LTcuODEyNSA3LjgxMjUgMy41IDcuODEyNSA3LjgxMjUtMy41IDcuODEyNS03LjgxMjUgNy44MTI1eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K";
export { SvgIconLocation as ReactComponent };